<button
    type="button" 
    class="tooltip-button"
    cdkOverlayOrigin
    #button
    #overlayOrigin="cdkOverlayOrigin"
    [valgTooltip]="tooltip"
    [positionY]="positionY">
    <mat-icon [svgIcon]="SvgIcon" *ngIf="isOpen"></mat-icon>
    <mat-icon [svgIcon]="SvgIconOutlined" *ngIf="!isOpen"></mat-icon>
    <span class="sr-only">{{ 'standard_input.tooltip.button' | translate }}</span>
</button>